import React, { useState } from 'react';
import { CONFIG } from 'config/config';
import { isMobile } from 'react-device-detect';
import { Text, Tooltip, View } from '@coinscrap/webapp-core';
import Info from 'assets/images/svgDynamic/Info';
import closeIcon from 'assets/images/svgStatic/close.svg';





export default function TooltipSimple({ ...props }) {
	const [isOpen, setIsOpen] = useState(false);
	return (
		<span
			onClick={() => setIsOpen(!isOpen)}
		/* onMouseEnter={() => !isMobile ? setIsOpen(true) : null}
	onMouseLeave={() => !isMobile ? setIsOpen(false) : null} */
		>
			<Tooltip
				open={isOpen}
				withArrow
				placement="right"
				enableClick={true}
				style={{
					containerComponent: {
						display: 'inline-block',
						cursor: 'pointer',
					},
					popperContentComponent: {
						backgroundColor: CONFIG.colors.white,
						borderRadius: 5,
						padding: 18,
						boxShadow: `${CONFIG.colors.primary} 0px 0px 2px 1px`,
						marginLeft: isMobile ? 20 : 24,
						border: 0,
						width: isMobile ? 'calc(100% - 40px)' : 600,
						maxWidth: 600,
					},
					arrowComponent: {
						color: CONFIG.colors.primary,
					},
				}}
				title={''}
				content={
					<View relativeSt fullWidthSt alignItemsStartSt>
						<View
							absoluteSt
							style={{
								zIndex: 50,
								width: 14,
								top: '-10px',
								right: '-5px',
								cursor: 'pointer',
							}}
							onClick={() => setIsOpen(false)}
						>
							<img src={closeIcon} alt={'close icon'} style={{ width: '100%' }} />
						</View>
						<Text exampleNormalSt style={{ color: CONFIG.colors.primary }}>
							{props.children}
						</Text>
					</View>
				}
			>
				<Info
					style={{ height: 20, width: 20, cursor: 'pointer' }}
					color={{
						icon: CONFIG.colors.primary,
					}}
				/>
			</Tooltip>
		</span>
	);
}
